/* ==========================================================================
   SearcherTrainHotel > Autocomplete
   ========================================================================== */

/* Modules */
const AutocompleteClient = require('@bluekiri/alexandria-contrib-components/components/autocomplete/client/js');
const config = require('./config');

/* Init  */
function initAutocomplete(selector, instance, configuration) {
    /* Instance references */
    const result = [];

    instance.element.querySelectorAll('[data-component="Autocomplete"]').forEach((item, index) => {
        /* Push autocomplete */
        result.push(
            AutocompleteClient(
                `${selector} [data-component="Autocomplete"][data-type="${config().type.autocomplete}-${index}"]`,
                {
                    ...configuration
                }
            )
        );
    });

    return result;
}

module.exports = {
    initAutocomplete
};
